var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useMemo, useState } from "react";
import { Button, Loading, MessageBanner, Modal, ModalFooter, } from "@folio/stripes/components";
import { useOkapiKy } from "@folio/stripes/core";
import { FormattedMessage, useIntl } from "react-intl";
import { useMutation, useQueryClient } from "react-query";
import { updatePeriodicalKultSubjectGroup } from "../../api/periodicalLibraryService";
import { useKultSubjectGroupOptions, usePeriodicalKultSubjectGroup, } from "../../hooks/usePeriodicalKultSubjectGroup";
import { PERIODICAL_LIBRARY_DETAIL_KEY } from "../../hooks/usePeriodicalLibraryActions";
import { PERIODICAL_KULT_SUBJECT_GROUP_QUERY_KEY } from "../../types/reports/kultSubjectGroup";
import { extractServerErrorMessage } from "../../utils/errorHandler";
import { RecekSelect } from "../inputs";
import { PeriodicalKultSubjectGroupValue } from "./PeriodicalKultSubjectGroupLine";
import css from "./PeriodicalKultSubjectGroupDialog.module.css";
export var PeriodicalKultSubjectGroupDialog = function (_a) {
    var _b, _c;
    var open = _a.open, titleId = _a.titleId, title = _a.title, onClose = _a.onClose;
    var formatMessage = useIntl().formatMessage;
    var kyInstance = useOkapiKy();
    var queryClient = useQueryClient();
    var _d = useState(null), pendingCode = _d[0], setPendingCode = _d[1];
    var _e = useState(null), errorMessage = _e[0], setErrorMessage = _e[1];
    var _f = usePeriodicalKultSubjectGroup(titleId, open), current = _f.data, isLoading = _f.isLoading, isError = _f.isError;
    var _g = useKultSubjectGroupOptions(open), _h = _g.data, options = _h === void 0 ? [] : _h, areOptionsLoading = _g.isLoading, isOptionsError = _g.isError;
    var storedCode = (current === null || current === void 0 ? void 0 : current.overrideOrphaned)
        ? ((_b = current.orphanedOverrideCode) !== null && _b !== void 0 ? _b : "")
        : (current === null || current === void 0 ? void 0 : current.manuallyOverridden)
            ? ((_c = current.code) !== null && _c !== void 0 ? _c : "")
            : "";
    var selectedCode = pendingCode !== null && pendingCode !== void 0 ? pendingCode : storedCode;
    var saveMutation = useMutation(function (code) {
        return updatePeriodicalKultSubjectGroup(kyInstance, titleId, code);
    }, {
        onMutate: function () { return setErrorMessage(null); },
        onSuccess: function () {
            queryClient.invalidateQueries([
                PERIODICAL_KULT_SUBJECT_GROUP_QUERY_KEY,
                titleId,
            ]);
            queryClient.invalidateQueries([PERIODICAL_LIBRARY_DETAIL_KEY]);
            queryClient.invalidateQueries(["periodicalLibraries"]);
            onClose();
        },
        onError: function (error) { return __awaiter(void 0, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = setErrorMessage;
                        return [4 /*yield*/, extractServerErrorMessage(error, formatMessage, formatMessage({
                                id: "ui-br-legaldeposits.periodicals.kultSubjectGroup.error.save",
                            }))];
                    case 1:
                        _a.apply(void 0, [_b.sent()]);
                        return [2 /*return*/];
                }
            });
        }); },
    });
    var handleClose = function () {
        if (!saveMutation.isLoading)
            onClose();
    };
    var dataOptions = useMemo(function () { return __spreadArray(__spreadArray([
        {
            value: "",
            label: formatMessage({
                id: "ui-br-legaldeposits.periodicals.kultSubjectGroup.option.automatic",
            }),
        }
    ], options.map(function (option) { return ({
        value: option.code,
        label: "".concat(option.group, ". ").concat(option.code, " \u2014 ").concat(option.label),
    }); }), true), ((current === null || current === void 0 ? void 0 : current.overrideOrphaned) &&
        !options.some(function (option) { return option.code === storedCode; })
        ? [{ value: storedCode, label: storedCode, disabled: true }]
        : []), true); }, [current === null || current === void 0 ? void 0 : current.overrideOrphaned, formatMessage, options, storedCode]);
    return (React.createElement(Modal, { open: open, size: "medium", label: formatMessage({ id: "ui-br-legaldeposits.periodicals.kultSubjectGroup.dialog.title" }, { title: title }), onClose: handleClose, footer: React.createElement(ModalFooter, null,
            React.createElement(Button, { buttonStyle: "primary", disabled: !current ||
                    isLoading ||
                    isError ||
                    areOptionsLoading ||
                    isOptionsError ||
                    selectedCode === storedCode ||
                    saveMutation.isLoading, onClick: function () { return saveMutation.mutate(selectedCode || null); } },
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.button.save" })),
            React.createElement(Button, { onClick: handleClose, disabled: saveMutation.isLoading },
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.button.cancel" }))) },
        errorMessage && (React.createElement(MessageBanner, { type: "error" }, errorMessage)),
        isError || isOptionsError ? (React.createElement(MessageBanner, { type: "error" },
            React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.periodicals.kultSubjectGroup.error.load" }))) : isLoading || areOptionsLoading ? (React.createElement(Loading, null)) : (current && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: css.currentState },
                React.createElement("strong", null,
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.periodicals.kultSubjectGroup.dialog.currentState" })),
                React.createElement("p", null,
                    React.createElement(PeriodicalKultSubjectGroupValue, { current: current })),
                React.createElement("p", null,
                    React.createElement(FormattedMessage, { id: current.notations.length
                            ? "ui-br-legaldeposits.periodicals.kultSubjectGroup.dialog.classification"
                            : "ui-br-legaldeposits.periodicals.kultSubjectGroup.dialog.noClassification", values: { notations: current.notations.join(", ") } }))),
            React.createElement(RecekSelect, { labelId: "ui-br-legaldeposits.periodicals.kultSubjectGroup.field.override", value: selectedCode, onChange: function (event) { return setPendingCode(event.target.value); }, dataOptions: dataOptions, disabled: saveMutation.isLoading }))))));
};
